/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/**
 * commentedit.ts
 * 06-03-2024 - Jelmer Jellema - Spin in het Web B.V. Apeldoorn NL
 * Component CommentEdit
 * Selector:
 * Er zijn er 2, 1 voor personeel en 1 voor projecten. Met zelfde template, dus even wat gehussel met een abstracte class
 */
import {Component, Directive, Input} from '@angular/core';
import {PersoneelDatumcomment} from '../../models/personeel_datumcomment';
import {Editmodelscherm} from '../abstracts/editmodelscherm';
import {ProjectDatumcomment} from '../../models/project_datumcomment';

///// abstract //////
@Directive()
abstract class CommentEdit<Recordclass extends (typeof PersoneelDatumcomment | typeof ProjectDatumcomment)> extends Editmodelscherm<Recordclass> {
  _starttitle = "Opmerking";
  icon = 'fas fa-comment-dots';
  fixedSize = true;
  fixedHeight = 520;
  fixedWidth = 470;

  //inputs puur voor weergaven
  @Input('naam') naam: string = "";
  @Input('datum') datum: string = "";

  /**
   * De kleurencombinaties waaruit gekozen kan worden, telkens achterkleur en voorkleur
   */
  readonly kleuren: [string, string][] = [
    ['#FFFFFF', '#000000'],
    ['#000000', '#FFFFFF'],
    ['#EE2E24', '#FFFFFF'],
    ['#047804', '#FFFFFF'],
    ['#F29400', '#FFFFFF'],
    ['#0000FF', '#E0E0E0']
  ];

  /**
   * Er wordt geklikt op een kleurencombi
   * @param kleur
   */
  setKleur(kleur: [string,string]) {
    this.record.achterkleur = kleur[0];
    this.record.voorkleur = kleur[1];
  }
}

@Component({
  templateUrl: './commentedit.html',
  selector: "personeelCommentEdit",
  styleUrls: ['commentedit.scss']
})
export class PersoneelcommentEdit extends CommentEdit<typeof PersoneelDatumcomment> {

  model = PersoneelDatumcomment;

  constructor() {
    super('debug');
  }
}

@Component({
  templateUrl: './commentedit.html',
  selector: "projectCommentEdit",
  styleUrls: ['commentedit.scss']
})
export class ProjectcommentEdit extends CommentEdit<typeof ProjectDatumcomment> {

  model = ProjectDatumcomment;

  constructor() {
    super('debug');
  }
}
